export interface ICompositeFileInfo {
    Name: string
    FileParts: ICompositeFilePart[]
}

export interface ICompositeFilePart {
    Order: number
    Type: ECompositeFilePartType
    DisplayName: string
    ReferenceObjectId: string
    FileVersion: number
}

export enum ECompositeFilePartType {
    File = 0,
    EmployeeReferences = 1,
    EmployeeReference = 2,
    EmployeeEmployementHistories = 3,
    EmployeeEmployementHistory = 4,
    EmployeeLicenses = 5,
    EmployeeLicense = 6,
    EmployeeCertifications = 7,
    EmployeeCertification = 8
}